import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { useLang } from "@/i18n";
import { ProductCard } from "@/components/ProductCard";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { ids } = useWishlist();
  const { t } = useLang();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (ids.length === 0) { setProducts([]); return; }
    Promise.all(ids.map((id) => api.get(`/products/${id}`).then((r) => r.data).catch(() => null)))
      .then((res) => setProducts(res.filter(Boolean)));
  }, [ids]);

  return (
    <div className="px-4 sm:px-8 lg:px-16 py-12 lg:py-16 fade-up min-h-[60vh]">
      <h1 className="font-serif-display text-4xl sm:text-5xl text-[#1A1F2C] text-center mb-12">{t("wishlist")}</h1>
      {products.length === 0 ? (
        <div className="flex flex-col items-center justify-center gap-4 text-[#6B7280] py-16">
          <Heart className="w-10 h-10" strokeWidth={1} />
          <p className="text-sm">{t("wishlist_empty")}</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-8">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
